import {AfterViewInit, ChangeDetectorRef, Component, DestroyRef, inject, Input, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize, timer } from 'rxjs';
import _ from 'lodash';
import { StandingGroup } from '../../../models/standingGroup';
import { LogService } from '../../../services/log.service';
import { Tournament } from '../../../models/tournament';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { PublicService } from '../../../services/public.service';

@Component({
  selector: 'app-public-standings',
  imports: [
    ButtonModule,
    TableModule,
    TooltipModule,
    TranslatePipe,
  ],
  templateUrl: './public-standings.component.html',
  styleUrl: './public-standings.component.scss',
})
export class PublicStandingsComponent implements OnInit, AfterViewInit {
  @Input() tournamentIdInput: string | undefined;
  
  private readonly destroy$ = inject(DestroyRef);
  public loading: boolean = true;
  public standingsGroups: StandingGroup[] = [];
  public tournament: Tournament | undefined;
  public tournamentId: string = '';

  constructor(
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private logService: LogService,
    private publicService: PublicService,
    private translate: TranslateService,
  ) {
    document.documentElement.style.backgroundColor = 'white'; // html
    document.body.style.backgroundColor = 'white'; // body
  }

  ngOnInit(): void {
    if(this.tournamentIdInput) {
      this.tournamentId = this.tournamentIdInput;
    } else {
      this.tournamentId = this.route.snapshot.paramMap.get('id')!;
    }
    // get standings once per minute
    timer(0, 60000).subscribe(() => {
      this.getStandings();
    });
  }

  ngAfterViewInit(): void {
    // wait for DOM to be printed
    setTimeout(() => this.sendHeight(), 100);
    // resize if content changes
    const observer = new ResizeObserver(() => this.sendHeight());
    observer.observe(document.body);
  }

  private getStandings(): void {
    if(!this.tournamentId) return;
    this.publicService.getPublicStandings(this.tournamentId)
      .pipe(
        takeUntilDestroyed(this.destroy$),
        finalize(() => this.loading = false),
      )
      .subscribe({
        next: (res) => {
          this.logService.debug('[Standings] - getPublicStandings', res);
          this.standingsGroups = _.orderBy(_.map(_.get(res, 'body.data'), (group: StandingGroup) => {
            return {
              ...group,
              groupName: `${this.translate.instant('field.group')} ${group.groupName}`, 
              standings: _.orderBy(group.standings, 'groupPosition')
            };
          }), 'groupName');
          setTimeout(() => {
            this.cdr.detectChanges();
          });
        },
        error: (err) => {
          this.logService.error('[Standings] - getPublicStandings', err, this.translate.instant('error.standings'));
        }
      });
  }

  private sendHeight(): void {
    const height = document.body.scrollHeight;
    window.parent.postMessage({ iframeStandingsHeight: height }, '*');
  }
}
